<template>
    <div class="section-notifications-detail">
        <ButtonCustom
            classBtn="section-notifications-detail__title"
            type="go-back"
            :text="dataDetail.title"
            :isGoBackHistory="false"
            @onClickButton="onClickGoBack"
        />
        <div class="section-notifications-detail__content">
            <div v-html="dataDetail.html" />
        </div>
    </div>
</template>
<script>
import ButtonCustom from "@/components/common/button";

export default {
    components: { ButtonCustom },
    props: {
        dataDetail: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },

    data() {
        return {};
    },

    methods: {
        onClickGoBack() {
            this.$emit("onGoBack");
        },
    },
};
</script>
